import { GET_ITEM_SIZE_COLOR_DATA } from "@/gql/inventory";

/** GraphQL InventoryItemType enum -> the PascalCase labels the sales entry table expects. */
export const INVENTORY_ITEM_TYPE_LABELS = {
	ITEM: "Item",
	SUB_ITEM: "SubItem",
	PACKAGE: "Package",
};

/**
 * Loads the color options, size chart and real inventory type for a line item's inventory
 * record. Used by the quote and order views when hydrating line items for the entry table.
 *
 * Resolves by id across every inventory type rather than picking a resolver from the line's
 * system category: "system" items such as VIP discounts and credits are stored as Items under
 * SubItem categories, and the category-based lookup returned null and threw for them.
 *
 * @param apollo   the component's $apollo client
 * @param item     line item carrying itemId
 * @param fallbackType label to report when the record cannot be found ("Item" | "SubItem")
 */
export async function fetchItemSizeColorData(apollo, item, fallbackType) {
	const res = await apollo.query({
		query: GET_ITEM_SIZE_COLOR_DATA,
		fetchPolicy: "no-cache",
		variables: { id: item.itemId },
	});

	const data = res.data.inventoryItem;
	if (!data) {
		console.warn(`[itemSizeColorData] Inventory item ${item.itemId} not found; rendering line without color/size data`);
		return { colorOptions: [], sizeChart: null, type: fallbackType };
	}

	const result = {
		colorOptions: data.colorOptions || [],
		type: INVENTORY_ITEM_TYPE_LABELS[data.itemType] || fallbackType,
	};
	// Only top-level Item records expose a size chart (inline fragment); leave the key off
	// for sub items and packages so the merge into the line item does not clobber anything.
	if ("sizeChart" in data) {
		result.sizeChart = data.sizeChart;
	}
	return result;
}
